import React from 'react';
import { DConfirmationModal } from '../../../../../dum';
import { useDeleteOrderQuotationMutation } from '../../../../../../services';

interface IDeleteOrderQuotationProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    orderQuotationId: number | null;
}

export function SDeleteOrderQuotationDialog({
    open,
    setOpen,
    orderQuotationId,
}: IDeleteOrderQuotationProps) {
    const [deleteMutation] = useDeleteOrderQuotationMutation();

    return (
        <DConfirmationModal
            open={open}
            setOpen={setOpen}
            callback={async () => {
                if (orderQuotationId) {
                    try {
                        await deleteMutation({
                            variables: {
                                OrderQuotationId: orderQuotationId,
                            },
                        });
                        setOpen(false);
                    } catch (e) {
                        console.error(e);
                    }
                }
            }}
        />
    );
}
